import { TagRequest } from '~src/httpClient/TAG/TagRequest';

import { ITagResult } from '../../../../../httpClient/serverApi/types/IResponse';
import { IAnalyticsExtConnectionId } from '../../../../types/ISiteSettingsForSiteAdmin';

export class DeleteAnalyticsExtConnectionSettingsRequest extends TagRequest<{}, ITagResult> {
  constructor(connectionId: IAnalyticsExtConnectionId) {
    super('analyticsextensions', 'deleteAnalyticsExtensionsConnection', connectionId);
  }
}
